import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveProviderStudios } from "./retrieve-provider-studios";
import type { ProviderStudioListItem } from "@shared-kernel/application/ports/provider/provider-repository";

const initialState: RetrievalState<ProviderStudioListItem[]> = { fetching: "idle", data: [] };

export const retrieveProviderStudiosReducer = createReducer<RetrievalState<ProviderStudioListItem[]>>(initialState, builder => {
  builder.addCase(retrieveProviderStudios.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveProviderStudios.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveProviderStudios.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
